import table from './table.vue'
const commonTable = {
    install:function(Vue) {
        Vue.component('common-table', table)
    }
}
// 导出该组件
export default commonTable